import { IconBuildingBank, IconDialpad, IconPlus, IconUser, IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const AddBankModal = ({ callback }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false)
    };

    const handleShow = () => setShow(true);

    async function submit() {
        let ifsc = document.getElementById("ifsc").value?.trim();
        let accountHolderName = document.getElementById("account-holder-name").value?.trim();
        let accountNumber = document.getElementById("account-number").value?.trim();
        let confirmAccountNumber = document.getElementById("confirm-account-number").value?.trim();
        if (ifsc && accountHolderName && accountNumber && confirmAccountNumber) {
            if (accountNumber === confirmAccountNumber) {
                loadingShow();
                let data = {
                    ifscCode: ifsc,
                    accountHolderName: accountHolderName,
                    accountNumber: accountNumber,
                }
                let resp = await postApi(data, urlApi.addBankDetails);
                loadingHide();
                if (resp.responseCode === 200) {
                    if (callback) {
                        callback();
                    }
                    toast.success(resp.message);
                    handleClose();
                } else {
                    toast.error('Failed to add bank');
                }
            } else {
                toast.warning('Account numbers do not match');
            }
        } else {
            toast.warning('All Fields Are Required.')
        }
    }

    return (
        <>
            <button onClick={handleShow} className='text-sm font-semibold border-primary !border px-4 py-2 rounded-full flex items-center gap-2'> <IconPlus size={18} /> Add Bank</button>
            <Modal show={show} onHide={handleClose} centered backdrop="static" >
                <Modal.Body className='rounded-xl p-0'>
                    <div className="flex justify-between items-center pt-3 px-4">
                        <p className="text-md font-semibold mb-0">Add Bank Details</p>
                        <button onClick={handleClose}> <IconX /></button>
                    </div>
                    <hr className='my-2' />

                    <div className='px-3 py-2 pb-4'>
                        <div className='mb-3'>
                            <label htmlFor="account-holder-name" className='text-sm font-semibold !mb-2'>A/C holder Name</label>
                            <div className='flex !border rounded-full px-3 py-2 items-center'>
                                <IconUser color='#BDBDBD' size={20} />
                                <input type='text' id='account-holder-name' className='w-full px-2 py-2 text-sm bg-transparent focus:border-none focus:outline-none' />
                            </div>
                        </div>
                        <div className='mb-3'>
                            <label htmlFor="account-number" className='text-sm font-semibold !mb-2'>A/C Number</label>
                            <div className='flex !border rounded-full px-3 py-2 items-center'>
                                <IconBuildingBank color='#BDBDBD' size={20} />
                                <input type='text' id='account-number' className='w-full px-2 py-2 text-sm bg-transparent focus:border-none focus:outline-none' />
                            </div>
                        </div>
                        <div className='mb-3'>
                            <label htmlFor="confirm-account-number" className='text-sm font-semibold !mb-2'>Confirm A/C Number</label>
                            <div className='flex !border rounded-full px-3 py-2 items-center'>
                                <IconBuildingBank color='#BDBDBD' size={20} />
                                <input type='text' id='confirm-account-number' className='w-full px-2 py-2 text-sm bg-transparent focus:border-none focus:outline-none' />
                            </div>
                        </div>
                        <div className='mb-3'>
                            <label htmlFor="ifsc" className='text-sm font-semibold !mb-2'>IFSC Code</label>
                            <div className='flex !border rounded-full px-3 py-2 items-center'>
                                <IconDialpad color='#BDBDBD' size={20} />
                                <input type='text' id='ifsc' className='w-full px-2 py-2 text-sm bg-transparent focus:border-none focus:outline-none' />
                            </div>
                        </div>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-between gap-3 px-3 py-2'>
                        <button className='modal-cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => submit()}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddBankModal